import { CascaderLanguage, SelectSubtitle } from "@/components";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Flex, Form, List, Modal } from "antd";
import { FC, useEffect } from "react";
import { ButtonSelf } from "../ButtonSelf";
import { SubtitlesAndVoiceFormProps, SubtitlesAndVoiceProps } from "./props";

const SubtitlesAndVoiceModal: FC<SubtitlesAndVoiceProps> = (props) => {
  const [form] = Form.useForm();

  const onFinish = (value: SubtitlesAndVoiceFormProps) => {
    props.onOk?.(value.subtitlesAndVoice);
  };

  useEffect(() => {
    if (props.open) {
      form.resetFields();
    }
  }, [props.open, props.data]);

  return (
    <Modal
      title="配置"
      maskClosable={false}
      open={props.open}
      width={800}
      centered
      forceRender
      okText="确定"
      cancelText="取消"
      onCancel={props.onClose}
      onOk={() => {
        form.submit();
      }}
    >
      <Form
        initialValues={{ subtitlesAndVoice: props.data }}
        form={form}
        onFinish={onFinish}
      >
        <Form.List name="subtitlesAndVoice">
          {(fields, { add, remove }) => (
            <>
              <Form.Item>
                <ButtonSelf block onClick={() => add()} icon={<PlusOutlined />}>
                  Add
                </ButtonSelf>
              </Form.Item>
              <List style={{ height: 500, overflow: "auto" }}>
                {fields.map((field) => (
                  <List.Item key={field.key}>
                    <Flex gap={20}>
                      <Form.Item label="字幕" name={[field.name, "subtitles"]}>
                        <SelectSubtitle filterNone={true} />
                      </Form.Item>
                      <Form.Item
                        label="人声"
                        name={[field.name, "voice"]}
                        rules={[{ required: true, message: "请选择人声" }]}
                      >
                        <CascaderLanguage
                          style={{ width: 240 }}
                          disabled={true}
                        />
                      </Form.Item>
                      <Form.Item hidden={fields.length === 1}>
                        <ButtonSelf
                          type="text"
                          icon={
                            <MinusCircleOutlined style={{ color: "red" }} />
                          }
                          onClick={() => remove(field.name)}
                        />
                      </Form.Item>
                    </Flex>
                  </List.Item>
                ))}
              </List>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};

export default SubtitlesAndVoiceModal;
